






















import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { AttentionApi, StateParam } from '../models/NDVModalTabs.model';

@Component({ components: { GridComponent: AgGridVue } })
export default class TabAttentions extends Vue {
  @Prop({ required: true, default: [] }) data!: AttentionApi[];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  private colsGrid(): ColDef[] {
    return Object.keys(this.data[0])
      .filter(
        col =>
          !['atenumero', 'ndvnumero', 'STATUS', 'TOTAL_REGISTROS'].includes(col)
      )
      .map(col => {
        let cb = null;
        if (col === 'Estado') {
          cb = {
            cellRenderer: (params: any) =>
              this.iconState({ state: params.data.Estado }),
          };
        }

        return {
          headerName: col,
          field: col,
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 220,
          minWidth: 100,
          ...cb,
        };
      });
  }

  iconState({ state }: StateParam): string {
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      state.toLowerCase() === 'emitida'
        ? 'rgb(255 242 38)'
        : state.toLowerCase() === 'facturada' ||
          state.toLowerCase() === 'transmitida'
        ? 'rgb(42 255 78)'
        : 'rgb(255 58 58)'
    }"></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${state}</a>`;
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }
}
